@if(models.length && component){
<div class="w-12 flex flex-justify-center">
    <div style="max-width: 1920px; overflow: hidden;"
         class="w-12">
        <div class="wrap">
            <!-- text box -->
            <text-box class="block p-t-20-x p-t-10-l p-t-15-s p-t-15-m "
                      [data]="component"
                      [textAlign]="'left'"></text-box>
            <!-- carousel -->
            <div class="pos-relative new-products-carousel-swiper-container">
                <div class="carousel-container">
                    <carousel class="default-swiper swiper-slide-per-view case-carousel default-pagination p-t-8 p-b-20-x p-b-10-l p-b-15-s p-b-15-m"
                              [slidesPerView]="'auto'"
                              [style.--pc-slides-ceil]="pcSlidesCeil"
                              [style.--pc-slides]="pcSlides"
                              [style.--pc-gutter]="pcGutter"
                              [navigation]="{
                                addIcons:false,
                                nextEl: '.case-next-' + uid,
                                prevEl: '.case-prev-' + uid,
                                }"
                              [scrollbar]="true"
                              [freeMode]="true"
                              imageViewRoot>
                        @for(model of models; track model.id){
                        <ng-template carouselSlide>
                            <div>
                                <a [routerLink]="model.data?.url"
                                   style="border-radius: 16.7px"
                                   class="block overflow-hidden m-b">
                                    <df-image-wrapper>
                                        <img [ratio]="'4/3'"
                                             [dfImage]="model.data?.image">
                                    </df-image-wrapper>
                                </a>
                                @if(getTagCategory(model)){
                                <a class="inline-block s1 b-a b-col-1 col-1 p-a p-t-2 p-b-2"
                                   style="border-radius: 20px"
                                   [routerLink]="getTagCategory(model)?.data?.url">
                                    {{getTagCategory(model)?.data?.name}}
                                </a>
                                }
                                <div [routerLink]="model.data?.url">
                                    @if(model.data?.name){
                                    <p class="h4 m-t-2 col-1">
                                        {{model.data?.name}}
                                    </p>
                                    }
                                    @if(model.data?.typeData?.shortDescription){
                                    <p class="p1 m-t-2 col-11">
                                        {{model.data?.typeData?.shortDescription}}
                                    </p>
                                    }
                                    <span type="button"
                                          class="m-t"
                                          [buttonStyle]="'text-button'">
                                        {{'Read more' | translate}}
                                    </span>
                                </div>
                            </div>
                        </ng-template>
                        }
                    </carousel>

                    <!-- navigation buttons-->
                    <div class="pos-absolute w-12 z-5 case-carousel-buttons"
                         [class.hidden]="models.length < pcSlides">
                        <button class="swiper-arrow-button pos-absolute inline-flex"
                                style="left: -20px"
                                [class]="'case-prev-' + uid"
                                aria-label="Previous slide"
                                type="button">
                            <i class="icon-chevron-left col-w"
                               aria-hidden="true"></i>
                        </button>
                        <button class="swiper-arrow-button pos-absolute right-0 inline-flex"
                                style="right: -20px"
                                [class]="'case-next-' + uid"
                                aria-label="Next slide"
                                type="button">
                            <i class="icon-chevron-right col-w"
                               aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
}